/**
 * PriorityBadge — P1/P2/P3. Subtle; never used as the sole signal.
 */

type Priority = "P1" | "P2" | "P3";

const COLORS: Record<Priority, string> = {
  P1: "#ee1d36",
  P2: "#ffae13",
  P3: "var(--mute)",
};

export function PriorityBadge({ priority }: { priority: Priority }) {
  return (
    <span
      style={{
        fontFamily: "var(--font-mono)",
        fontSize: 11,
        fontWeight: 600,
        color: COLORS[priority],
      }}
      title={`Priority ${priority}`}
    >
      {priority}
    </span>
  );
}
